import { Box, Button, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

import { CardAvatarDisabled } from './assets/card-avatar-disabled';
import { routeErrorBoundaryStyles } from './route-error-boundary.styles';

import theme from '@/theme/mui';

const RouteErrorBoundary = () => {
  const error = useRouteError() as Error;

  const isDev = process.env.NODE_ENV === 'development';
  const { t } = useTranslation();

  return (
    <ThemeProvider theme={theme}>
      <Box sx={routeErrorBoundaryStyles.container}>
        <Box sx={routeErrorBoundaryStyles.content}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <CardAvatarDisabled />
          </Box>
          <Typography variant="h5" sx={routeErrorBoundaryStyles.title}>
            {t('errorBoundary.title')}
          </Typography>
          <Typography sx={routeErrorBoundaryStyles.message}>
            {t('errorBoundary.message')}
          </Typography>
          {isDev && error?.message && (
            <Typography color="error">{error.message}</Typography>
          )}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 3,
              width: '100%',
            }}
          >
            <Button
              sx={routeErrorBoundaryStyles.button}
              onClick={() => window.location.reload()}
            >
              {t('errorBoundary.button')}
            </Button>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default RouteErrorBoundary;
